<template lang="pug">
  v-container(fluid)
    v-card.pa-2.ma-2.mx-0(flat)
      v-row(no-gutters v-if="!setFreeDay")
        v-col
          CalendarListItem.mt-2(
            :menuGroupItem="offerItem" :offerItem="offerItem" :date="date"
          )
      v-row(no-gutters v-else)
        v-col
          CalendarListItem( :eventName="getEventName")

</template>

<script lang="ts">
import Vue from 'vue'
import CalendarListItem from "@/components/dailymenu/calendar/CalendarListItem.vue";
import DailyMenuOffer from "@/model/dailymenu/DailyMenuOffer";
import {GET_CALENDAR_EVENTS, GET_LOADING_WEEKCALENDAR} from "@/store/getter-types";
import {Component, Prop} from "vue-property-decorator";
import MenuReservationItem from "@/model/dailymenu/MenuReservationItem";
import CalendarEventForDay from "@/model/calendar/CalendarEventForDay";
import moment from "moment";

@Component({
  components: {
    CalendarListItem
  }
})

export default class CalendarList extends Vue {

  @Prop({type: Object as () => DailyMenuOffer, required: true}) offerItem!: DailyMenuOffer
  @Prop({type: Date}) date!: Date
  @Prop({type: Object as () => MenuReservationItem}) reservationItem!: MenuReservationItem

  private setFreeDay: boolean = false
  private events: CalendarEventForDay[] | undefined = undefined

  get loading(): boolean {
    return this.$store.getters[GET_LOADING_WEEKCALENDAR]
  }

  get getEventName(): string{
    const foundEvent: CalendarEventForDay | undefined = this.events!.find((item: CalendarEventForDay) => moment(item.date).format('DD.M.YYYY') == moment(this.offerItem.formatedDate).format('DD.M.YYYY'))
    if (foundEvent!.kind.name == 'holiday') {
      return 'Prázdniny'
    } else if(foundEvent!.kind.name == 'free_day') {
      return 'Voľný deň'
    } else {
      return ''
    }
  }

  getCurrentEvent(): void {
    if (this.events) {
      const foundEvent: CalendarEventForDay | undefined = this.events.find((item: CalendarEventForDay) => moment(item.date).format('DD.M.YYYY') == moment(this.offerItem.formatedDate).format('DD.M.YYYY'))
      this.setFreeDay = !!foundEvent
    }
  }

  mounted(): void {
    this.events = this.$store.getters[GET_CALENDAR_EVENTS]

    this.getCurrentEvent()
  }
}
</script>

<style lang="stylus" scoped>

.calendar-list
  padding 2%
  flex-direction column
</style>
